import React from "react";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import AnalysisCard from "./AnalysisCard";

const AnalysesByTypePanel = ({ title, farm, farmGroups, offlineBudgets, datasets, downloadBudget, showVisibility }) => {
    return (
        <Panel title={title} midBlue className="u-mb-lg">
            <PanelBody grey>
                {offlineBudgets.map((offlineBudget, index) => (
                    <AnalysisCard key={offlineBudget.budget.id} farm={farm} farmGroups={farmGroups} showVisibility={showVisibility} offlineBudget={offlineBudget} index={index} datasets={datasets} downloadBudget={downloadBudget} parentTitle={title} />
                ))}
            </PanelBody>
        </Panel>
    );
};

export default AnalysesByTypePanel;
